module.exports={
    message:{
        high_loan:'วงเงินสูงสุดที่กู้ได้',
        home:'หน้าหลัก',
        loginIn:'เข้าสู่ระบบ',
        loginOut:'ออกจากระบบ',
        immit_loan_quickly:'สมัครสินเชื่อ',
        get_menoy:'รับเงิน',
        info_cjwt:'คำถามที่พบบ่อย',
        info_dkzf:'ชำระสินเชื่อ',
        info_lxwm:'ติดต่อเรา',
        zc_and_sk:'ลงทะเบียนและรับเงิน',
        loan_mount:'วงเงินกู้',
        loan:'สินเชื่อ',
        loan_limit:'ระยะเวลากู้ยืม',
        date:'วัน',
        name:'ชื่อและนามสกุล',
        tel_id:'เบอร์โทรศัพท์',
        code:'รหัสผ่าน',
        apply_loan:'สมัครสินเชื่อ',
        cx_simple:'ขั้นตอนง่าย ๆ',
        no_dy:'ไม่ต้องค้ำประกัน',
        xq_simple:'ขั้นตอนการต่ออายุง่ายๆ',
        pay_simple:'วิธีการชำระเงินง่ายๆ',
        day_income:'รับเงินระหว่างวัน',
        loan_high_money:'วงเงินกู้สูง',
        why_choose:'ทำไมถึงเลือก',
        loan_5_min:'สมัครสินเชื่อใน 5 นาที',
        loan_jl:'แรงจูงใจในการกู้ยืมในครั้งต่อไป',
        simple:'ความสะดวก',
        everywhere:'ทุกที่ทุกเวลา',
        weiWang:'บารมี',
        keepScript:'เก็บข้อมูลของคุณเป็นความลับแน่นอน',
        deal_loan:'โซลูชั่นทางการเงินที่ทันสมัย',
        run_qg:'ให้บริการทั่วประเทศ',
        online_zc:'ขั้นตอนการลงทะเบียนระบบออนไลน์ทั้งหมด',
        simple_3_step:'รับเงินได้ด้วย 3 ขั้นตอนง่าย ๆ',
        input_per_info:'กรอกข้อมูลส่วนตัว',
        contact_U:'เราจะติดต่อกลับ',
        loan_quickly:'สินเชื่อเงินด่วน',
        simple_2_loan:'กู้เงินง่าย  อนุมัติใน 2 ชั่วโมง',
        jd_search:'สอบถามความคืบหน้า',
        history_bill:'ใบเสร็จย้อนหลัง',
        repay_now:'ชำระหนี้ทันที',
        edit_news:'แก้ไขข้อมูล',
        no_bill:'คุณไม่มีรายการคำสั่งที่สมัคร',
        submit_bill_succ:'ส่งรายการคำสั่งสำเร็จ',
        deal_u_bill:'รายการคำสั่งของคุณกำลังดำเนินการ',
        cl_bill:'รายการคำสั่งกำลังดำเนินการ',
        out_jg:'คาดว่าจะได้ผลการตรวจสอบภายใน 24 ชั่วโมง',
        tg_wait_loan:'ตรวจสอบผ่าน รอเงินกู้',
        work_2_loan:'คาดว่าจะได้รับเงินกู้ภายใน 2 วันทำการ',
        loan_success:'กู้เงินสำเร็จ',
        serch_account:'โปรดตรวจสอบบัญชีของคุณ',
        orderId:'หมายเลขรายการคำสั่ง',
        loan_amout:'วงเงินกู้',
        qs:'จำนวนงวด',
        repay_time:'เวลาชำระหนี้',
        apply_status:'สถานะการสมัคร',
        see_detail:'ดูรายละเอียด',
        shz:'ระหว่างตรวจสอบ',
        sh_refuse:'ปฏิเสธการตรวจสอบ',
        sh_tg:'ผ่านการตรวจสอบ',
        cancle:'ยกเลิกแล้ว',
        yh_manger:'ค่าธรรมเนียมการจัดการผู้ใช้',
        apply_quick_loan:'ค่าธรรมเนียมการสมัครด่วน',
        interest:'อัตราดอกเบี้ย',
        Overdue_fj:'ค่าปรับค้างชำระ',
        apply_date:'วันที่สมัคร',
        bill_detail:'รายละเอียดใบเสร็จ',
        com_repay:'ยืนยันการชำระคืน',
        basc_info:'ข้อมูลพื้นฐาน',
        bank_amount:'บัญชีธนาคาร',
        login_code:'รหัสผ่านเข้าสู่ระบบ',
        no_edit_pasd:'คุณไม่สามารถแก้ไขข้อมูลได้ชั่วคราว',
        add_bank:'เพิ่มบัญชีธนาคาร',
        default:'ค่าเริ่มต้น',
        com_edit_bank:'ยืนยันการแก้ไขบัญชีธนาคารนี้ให้เป็นบัญชีธนาคารเริ่มต้นหรือไม่',
        yhy:'ตรวจสอบและยืนยันแล้ว',
        hy_w:'ยังไม่ได้ตรวจสอบและยืนยัน',
        hy_error:'ตรวจสอบและยืนยันล้มเหลว',
        edit_bank:'แก้ไขบัญชีธนาคาร',
        infos_rz_bank:'บัญชีธนาคารของคุณไม่ได้รับการยืนยัน  โปรดยืนยันก่อน',
        set_success:'ตั้งค่าสำเร็จ',
        bank_no_set_deauflt:'บัญชีนี้ไม่รองรับการตั้งค่าบัญชีธนาคารเริ่มต้น',
        delete_success:'ลบสำเร็จ',
        no_delete_1bank:'บัญชีธนาคารที่ผูกเหลือเพียงบัญชีเดียว，ม่สามารถยกเลิกการผูกได้',
        ipt_psd:'ใส่รหัสผ่านใหม่',
        ipt_psd_again:'ใส่รหัสผ่านใหม่อีกครั้ง',
        js_edit_psd:'*หมายเหตุ：โปรดระมัดระวังในการแก้ไขรหัสผ่านของคุณ！',
        edit_psd:'แก้ไขรหัสผ่าน',
        del:'ลบ',
        ts:'แสดง',
        reback:'กลับ',

        psd_login:'เข้าสู่ระบบด้วยรหัสผ่าน',
        code_login:'เข้าสู่ระบบด้วยรหัสยืนยัน',
        send_code:'ส่งรหัสยืนยัน',
        IDcardZM:'ด้านหน้าบัตรประชาชน',
        IDcardFM:'ด้านหลังบัตรประชาชน',
        hold_ID:'ถือบัตรประชาชนด้านหน้า',
        work_photo:'รูปถ่ายใบอนุญาตทำงานของฉัน',
        jx:'ดำเนินการต่อ',
        img_upload_agagin:'อัปโหลดรูปภาพไม่สำเร็จ  โปรดอัปโหลดอีกครั้ง',
        img_upload_success:'อัปโหลดรูปภาพสำเร็จ',
        upLoad_image_no:'คุณมีรูปถ่ายที่ยังไม่ได้อัปโหลด โปรดอัปโหลดก่อน',
        Parameter_error:'พารามิเตอร์ข้อผิด',

        gender:'เพศ',
        fullName:'ชื่อและนามสกุล',
        ID:'บัตรประจำตัวประชาชน',
        age:'วันเดือนปีเกิด',
        education:'ระดับการศึกษา',
        marriage:'สถานภาพ',
        income:'รายได้',
        Career:'อาชีพ',
        Companyphone:'เบอร์โทรศัพท์บริษัท',
        compay:'ชื่อบริษัท',
        adress:'ที่อยู่',
        city:'เมือง',
        get_fb_link:'รับลิ้งค์ FaceBook',
        cancel:'ยกเลิก',
        determine:'ยืนยัน',

        basc_post_success:'ส่งข้อมูลพื้นฐานสำเร็จ',
        jcNEWS:'โปรดตรวจสอบความครบถ้วนของข้อมูล',

        xl_gzyx:'ต่ำกว่ามัธยมศึกษา',
        xl_gz_zz:'มัธยมศึกษา/ปวช.',
        xl_dz:'ปวส',
        xl_bk:'ปริญญาตรี',

        hy_wh:'โสด',
        hy_yh:'แต่งงาน',
        hy_ly:'หย่าร้าง',
        hy_so:'หม้าย',

        sr_3jyx:'3000 และต่ำกว่า',
        sr_3d6:'3001~6000',
        sr_6d9:'6001~6000',
        sr_9d12:'9001~12000',
        sr_1ys:'12000และสูงกว่า',

        gx_fq:'บิดา',
        gx_mq:'มารดา',
        gx_po:'คู่สมรส',
        gx_zn:'บุตร',
        gx_qtqs:'ญาติคนอื่น ๆ',
        gx_py:'เพื่อน',
        gx_ts:'เพื่อนร่วมงาน',
        gx_qt:'อื่น ๆ',

        zy_js:'อาจารย์',
        zy_fuy:'บริกร',
        zy_sj:'คนขับรถ',
        zy_wy:'เสมียน',
        zy_kf:'บริการลูกค้า',
        zy_xsy:'พนักงานขาย',
        zy_yj:'ไปรษณีย์',
        zy_ys:'แพทย์',
        zy_jishi:'ช่างเทคนิค',
        zy_fy:'นักแปล',
        zy_ls:'ทนาย',

        zy_kj:'นักบัญชี',
        zy_zj:'ที่ปรึกษา/นายหน้า',
        zy_tx:'เกษียณอายุ',
        zy_xs:'นักเรียน',
        zy_jy:'ค้าขาย',
        zy_jc:'ตำรวจ , ทหาร',
        zy_nm:'เกษตรกร , ชาวประมง',
        zy_bw:'หน่วยป้องกัน',
        zy_yg:'กรรมกร',
        zy_jw:'แม่บ้าน',
        zy_jz:'พาร์ทไทม์（เป็นชั่วโมง)',
        zy_qt:'อื่น ๆ',

        contct:'ผู้ติดต่อ',
        phone:'เบอร์โทรศัพท์',
        relation:'ความสัมพันธ์เป็น',
        social_info:'ข้อมูลโซเชียล',

        holdName:'ชื่อและนามสกุลผู้ถือบัตร',
        idcar:'หมายเลขประจำตัวประชาชน',
        bankCard:'บัญชีธนาคาร',
        bankNwes:'ข้อมูลธนาคาร',
        borrowImmediate:'กู้เงินเดี๋ยวนี้',
        jiancha:'โปรดตรวจสอบข้อมูลบัญชีธนาคารของคุณ',
        banks_binded:'บัตรธนาคารนี้เชื่อมโยงแล้ว กรุณาเปลี่ยนเป็นเชื่อมโยงอีกครั้ง',
        add_com:'ยืนยันการเพิ่ม',
        add_success:'เพิ่มสำเร็จ',

        order_cancel:'ยกเลิกคำสั่งซื้อ',
        order_shcg:'ตรวจสอบและอนุมัติสำเร็จ',
        order_shjj:'ตรวจสอบและอนุมัติไม่สำเร็จ',
        order_wait:'รอเงินกู้',
        order_loan_success:'กู้เงินสำเร็จ',
        order_refuse:'ปฏิเสธการกู้เงิน',
        order_fkz:'กำลังดำเนินการกู้เงิน',

        all:'ทั้งหมด',
        dai_wac:'รอชำระหนี้',
        bill_iwc:'เรียบร้อยแล้ว',
        bill_repay_status:'สถานะการชำระหนี้',
        bill_whk:'ยังไม่ได้ชำระหนี้',
        bill_tchk:'เลื่อนการชำระหนี้',
        bill_whq:'ยังไม่ได้ชำระหนี้',
        bill_sq_status:'สถานะการสมัคร',
        bill_yhk:'ชำระหนี้แล้ว',
        bill_jkqx:'ระยะเวลากู้ยืม',
        edit_grxx:'แก้ไขข้อมูลส่วนบุคคล',
        edit_tips:'*หมายเหตุ:ข้อมูลนี้เกี่ยวกับความสามารถในการกู้เงินของคุณหรือไม่  กรุณากรอกตามความเป็นจริง！',
        edit_com:'ยืนยันการแก้ไข',
        edit_success:'แก้ไขสำเร็จ',
        edit_error:'แก้ไขไม่สำเร็จ',
        error_code:'รหัสผ่านผิด',
        borrow_lijk:'กู้เงินทันที',
        borrow_wbdyhk:'ยังไม่ได้ผูกบัญชีธนาคาร',
        borrow_bfhtj:'ไม่มีคุณสมบัติ',
        borrow_uncomplete:'มีรายการคำสั่งรอดำเนินการ',
        borrow_sfbq:'ข้อมูลบัตรประจำตัวประชาชนไม่ครบ',
        borrow_nlbg:'อายุไม่ถึง',
        borrow_rzxxbq:'ข้อมูลการยืนยันไม่ครบ',
        borrow_system:'ซ่อมแซมระบบ',
        borrow_choose_bank:'โปรดเลือกบัญชีธนาคารที่ถูกต้อง',
        borrow_bfhdktj:'ไม่มีคุณสมบัติในการกู้เงิน',
        pay_total:'ยอดที่ต้องชำระทั้งหมด',
        add_bank_tips:'*หมายเหตุ: เงินที่กู้ยืมจะถูกส่งไปยังบัตรธนาคารของคุณโดยตรง  โปรดกรอกข้อมูลบัตรธนาคารให้ถูกต้อง  มิฉะนั้นอาจทำให้เงินกู้ไม่สามารถเข้าบัญชีธนาคารของคุณตามปกติได้!',
        repay_style:'วิธีการชำระหนี้',
        repay_hklx:'ประเภทการชำระหนี้',
        repay_tips:'*หมายเหตุ: ไม่มีการลดดอกเบี้ยสำหรับการชำระหนี้ก่อนกำหนด！',
        repay_skdw:'หน่วยรับเงิน',
        repay_bank_news:'ข้อมูลธนาคาร',
        repay_zh_bank:'ชื่อสาขาธนาคาร',
        repay_zh:'บัญชีธนาคาร',
        repay_next_date:'เวลาชำระหนี้งวดต่อไป',
        repay_map_new:'ข้อมูลแผนที่',
        repay_server_money:'ค่าบริการ',
        repay_code:'รหัสธุรกรรม',
        repay_bld:'ที่อยู่ร้านสะดวกซื้อ',
        repay_hm:'ชื่อผู้ใช้',
        repay_zh1:'บัญชี',
        repay_bank:'ธนาคาร',
        repay_money:'ยอดเงินชำระหนี้',
        repay_tq_tips:'*หมายเหตุ: ไม่มีการลดดอกเบี้ยสำหรับการชำระหนี้ก่อนกำหนด!',
        order_no_message:'คุณไม่มีรายการที่รอชำระหนี้!',

        banksAccount:'บัญชีธนาคาร',
        xians:'ชำระหนี้ธนาคาร',
        xianxia:'การชำระหนี้ร้านค้า',
        quank:'เต็มจำนวน',
        xuq:'ต่ออายุ',
        enterPhone:'โปรดใส่หมายเลขโทรศัพท์',
        ver_code:'รหัสยืนยัน',
        message_ipt_code:'โปรดใส่รหัสยืนยัน',
        ver_code_success:'ส่งรหัสยืนยันสำเร็จ',
        ver_code_error:'ส่งรหัสยืนยันล้มเหลว',
        login_success:'เข้าสู่ระบบสำเร็จ',
        login_error:'เข้าสู่ระบบล้มเหลว',
        index_ts:'กู้เงินง่าย อนุมัติใน 3 ชั่วโมง',
        pasenoLOAD:'คุณไม่สามารถกู้เงินได้ชั่วคราว',
        index_rzxx:'ข้อมูลการยืนยัน',

        ipt_correct_id:'กรุณากรอกหมายเลขประจำตัวประชาชนที่ถูกต้อง',
        fb_error:'รูปแบบ facebook ไม่ถูกต้อง',
        sub_new_error:'การส่งข้อมูลล้มเหลว',
        ipt_has_uIpt:'คุณมีเนื้อหาที่ยังไม่ได้กรอก',

        trait_1:'สินเชื่อจาก',
        trait_1_1:'1-5 ล้าน ดอง',
        trait_2:'ได้รับเงิน',
        trait_2_1:'ของวันนี้',
        trait_3:'วิธีชำระเงิน',
        trait_3_1:'ที่ง่าย',
        trait_4:'ไม่ต้องการ',
        trait_4_1:'การค้ำประกัน',
        trait_5:'ขั้นตอนการต่ออายุ',
        trait_5_1:'ที่ง่าย',
        step1:'อัปโหลดรูปภ่าย',
        step2:'กรอกข้อมูลพื้นฐาน',
        yjh_loan:'มีโอกาสกู้เงิน',
        sel_ipt:'เลือกกรอก',
        sel_ipt1:'(เลือกกรอก)',
        must_ipt:'จำเป็นต้องกรอก',
        upload_scz:'กำลังอัปโหลด...',
        upload_scz_error:'อัปโหลดล้มเหลว',
        zc:'ลงทะเบียน',
        info_lxwm_time:'เวลางาน：วันจันทร์-วันเสาร์：08:00-17:00',
        info_lxwm_server:'ศูนย์บริการลูกค้า:',
        info_dkzf_step1:'ไปที่สาขาของธนาคารที่ใกล้ที่สุดหรือทำธุรกรรมที่ร้านสะดวกซื้อใกล้เคียง',
        info_dkzf_step2:'ชำระนี้และเก็บใบเสร็จรับเงินที่ได้จากธนาคาร',
        info_cjwt_ybzx:'คำถามทั่วไป',
        info_cjwt_Q1:'การขอสินเชื่อจะต้องมีคุณสมบัติอะไรบ้าง？',
        info_cjwt_Q2:'ฉันจะต้องเตรียมเอกสารข้อมูลอะไรบ้างจึงจะขอสินเชื่อผ่าน？',
        info_cjwt_Q3:'บริษัทของคุณให้บริการสินเชื่อในภูมิภาคและจังหวัดใดบ้าง？',
        info_cjwt_Q4:'ฉันกรอกใบสมัครแล้ว ฉันต้องทำอะไรต่อไป？',
        info_cjwt_a1:'ในการรับเงินกู้ คุณต้องเป็นพลเมืองของประเทศของคุณที่มีอายุระหว่าง 18 ถึง 50 ปีพร้อมบัตรประจำตัวที่ถูกต้อง',
        info_cjwt_a2:'คุณจะต้องให้ข้อมูลส่วนบุคคลของคุณเพื่อให้มีคุณสมบัติ',
        info_cjwt_a3:'เราให้บริการในทุกจังหวัด',
        info_cjwt_a4:'เมื่อใบสมัครของคุณได้รับการอนุมัติ  คุณจะได้รับการแจ้งเตือนทาง SMS  และคุณจะได้รับเงินกู้ภายใน 2 ชั่วโมงหลังจากเซ็นอนุมัติเงินกู้',
        info_cjwt_hddk:'ได้รับสินเชื่อ',
        info_cjwt_hddk_Q1:'หากภายใน 2 ชั่วโมงเราไม่ได้รับเงินกู้ จะต้องทำอย่างไร？',
        info_cjwt_hddk_a1:'หลังจากผ่านไป 2 ชั่วโมง  หากคุณยังไม่ได้รับเงินกู้ โปรดติดต่อสายด่วน：',
        info_cjwt_dkzf:'ชำระสินเชื่อ',
        info_cjwt_dkzf_Q1:'ฉันสามารถชำระหนี้ก่อนกำหนดได้หรือไม่？',
        info_cjwt_dkzf_a1:'ได้ค่ะ  คุณสามารถชำระเงินกู้ก่อนวันครบกำหนดชำระหนี้ได้',
        info_cjwt_dkzf_Q2:'จะเกิดอะไรขึ้นถ้าฉันชำระหนี้ทั้งหมดหลังจากวันครบกำหนดชำระ？',
        info_cjwt_dkzf_a2:'เพื่อความสะดวกที่สุด  คุณควรชำระคืนเงินกู้ตามวันที่กำหนดชำระหนี้ หากคุณชำระหนี้ช้า จะมีการเรียกเก็บค่าธรรมเนียมความล่าช้า',

        deal_photo_cj:'ครอบตัด',
        deal_photo_xz:'หมุนรูปภาพ',
        deal_photo_tjtp:'ส่งรูปภาพ',
        deal_photo_cz:'แสดง',
        deal_photo_text:'โปรดปรับขนาดของกรอบครอบตัดสีน้ำเงินก่อนดังภาพตัวอย่างที่แสดง  เมื่อปรับเสร็จแล้ว ให้คลิกปุ่มครอบตัด  จากนั้นคลิกปุ่มส่งรูปภาพ',
        deal_photo_sl:'แสดงตัวอย่าง',

        ipt_old_psd:'รหัสผ่านเดิม',

        verity_code:'โปรดใส่รหัสผ่าน',
        verity_iphone:'โปรดใส่หมายเลขโทรศัพท์ที่ถูกต้อง',
        loan_data:'เวลากู้เงิน',
        rixi_fei:'ดอกเบี้ยรายวัน',
        yuqi_fei:'อัตราดอกเบี้ยรายวัน',
        cs_mima:'รหัสผ่านเข้าสู่ระบบคือเลข 6 ตัวท้ายหมายเลขโทรศัพท์มือถือที่ระบุในการลงทะเบียน',


      btn_info_41:'กำลังตรวจสอบและอนุมัติรายการคำสั่ง',
      btn_info_44:'ปฏิเสธการตรวจสอบและอนุมัติ',
      btn_info_30:'รอเงินกู้',
      btn_info_1:'คุณมีรายการคำสั่ง 1 รายการ',
      btn_info_2:'รายการคำสั่งของคุณหมดอายุแล้ว',
      btn_info_31:'ปฏิเสธการเงิน',

      loan_dz:'ยอดเงินที่เข้าบัญชี',
      loan_dq:'วันที่ครบกำหนด',
      repay_beizhu:'หมายเหตุ',

      yys_rz:'การยืนยันร้านค้าที่ดำเนินการ',
      yys_code_success:'ส่งรหัสยืนยันสำเร็จ  โปรดใส่รหัสยืนยัน',
      yys_code_error_click:'ส่งรหัสยืนยันไม่สำเร็จ  โปรดคลิกอีกครั้ง',
      yys_code_inpt_again:'โปรดใส่รหัสยืนยันใหม่อีกครั้ง',
      yys_error_code:'รหัสยืนยันไม่ถูกต้อง  กรุณากรอกใหม่อีกครั้ง',
      yys_sub:'ส่ง',
      yys_tel:'เบอร์โทรศัพท์มือถือ',
      yys_code:'รหัสยืนยัน',
      yys_sub_success:'ส่งเรียบร้อย',
      Yys_cxfs:'ส่งรหัสยืนยันอีกครั้ง',

      th_yys_sjh:'เบอร์โทรศัพท์',
      th_yys_yzm:'รหัสยืนยัน',
      th_yys_qsryzm:'กรุณากรอกรหัสยืนยัน',
      th_yys_sfz:'บัตรประชาชน',
      th_yys_qsrsfz:'กรุณากรอกบัตรประจำตัว',
      th_yys_fhsyy:'ย้อนกลับก่อนหน้า',
      th_yys_yysmm:'รหัสผ่านเข้าสู่ APP',
      th_yys_qsryysmm:'กรุณากรอกรหัสผ่านเข้าสู่ APP',
      th_yys_qjxrzsfz:'โปรดยืนยันบัตรประจำต่อไป',
      th_yys_hqyzm:'รับรหัสยืนยัน',
      th_yys_qx:'การอนุญาต',
      th_yys_rzcg:'การรับรองสำเร็จ',

        // 一下是新添加的
        basc_photo:'แนบเอกสาร',
        yys_tg:'ข้าม',
        index_shcg:'ผ่านการตรวจสอบ',
        index_dws:'รอตรวจสอบ',
        index_jdcx:'ตรวจสอบ',
        index_sqdd:'สมัคร',
        index_grzx:'ส่วนบุคคล',
        index_rz_tips:'คุณยังไม่ผ่านการรับรองโปรดตรวจสอบข้อมูลก่อน',
        sch_shz:'อยู่ระหว่างตรวจสอบ',
        sch_dtx:'รอถอน',
        sch_dhk:'รอชำระเงิน',
        sch_ywc:'เสร็จ',
        sch_ckjd:'ตรวจสอบความคืบหน้า',
        sch_ytg:'ผ่านการตรวจสอบ',
        sch_tx:'ถอนเงิน',
        sch_txz:'ระหว่างถอนเงิน',
        sch_yfk:'อนุมัติแล้ว',
        sch_hk:'ชำระ',
        sch_yjj:'ปฏิเสธแล้ว',
        sch_cxjk:'ยื่นสินเชื่อใหม่',
        with_txjw:'จำนวนเงินที่ได้รับ',
        with_tx_tips:'ดอกเบี้ย: ขึ้นอยู่กับวันที่กู้จริง',
        with_tx_ddxx:'ข้อมูลการสั่งซื้อ',
        with_tx_jkr:'ผู้กู้',
        with_tx_jkts:'วันที่ยืม',
        with_tx_jkje:'จำนวนเงินกู้',
        with_tx_dzje:'จำนวนเงินที่ได้รับ',
        with_tx_yhje:'จำนวนเงินที่ต้องชำระ',
        with_tx_skyh:'ธนาคารผู้รับผลประโยชน์',
        with_tx_skzh:'เลขบัญชีของผู้รับผลประโยชน์',
        with_tx_ljtx:'ถอนตอนนี้',
        view_sc_sqje:'จำนวนเงินที่ยื่ยสินเชื่อ',
        view_sc_jkmx:'รายละเอียดเงินกู้',
        view_sc_sqsj:'เวลาในการสมัคร',
        view_sc_sx:'รีเฟรช',
        repay_jlhk:'ใกล้ถึงวันชำระหนี้',
        repay_nyyq:'เกินกำหนดชำระ',
        repay_hkr:'วันครบกำหนดชำระ',
        repay_qjkhk:'กรุณาชำระคืนโดยเร็วที่สุด',
        repay_yqf:'ค่าธรรมเนียมของการเกินกำหนดชำระ',
        repay_yhze:'การชำระคืนทั้งหมด',
        borrow_dksq:'การขอสินเชื่อ',
        borrow_nmqzg:'คุณสามารถยื่นได้สูงสุด',
        my_title:'ส่วนบุคคล',
        my_yhzhgl:'การจัดการบัญชีธนาคาร',
        my_zxkf:'บริการให้คำปรึกษา',
        my_logout:'ออกจากระบบ',
        ser_qxzkf:'โปรดเลือกบริการลูกค้าที่คุณต้องการปรึกษา',
        ser_gfgh:'โทรศัพท์อย่างเป็นทางการ',
        ser_nkydj:'คุณสามารถคลิกที่หมายเลขโทรศัพท์ด้านล่างได้โดยตรงจากนั้นระบบจะเปลี่ยนเส้นทางไปยังอินเทอร์เฟซการโทรของคุณ',
        ser_zalo:'เจ้าหน้าที่ Line',
        ser_addZalo:'คุณสามารถเพิ่มหมายเลข Line ด้านล่างเพื่อติดต่อกับเรา',
        // yys_reset_wjmm:'ลืมรหัสผ่าน',

      /**新版sass新添加的***/

      service_timeout:'คำขอหมดเวลา รีเฟรชแล้วลองอีกครั้ง',
      for_pass:'ลืมรหัสผ่าน รับรหัสผ่านทางข้อความ',
      use_phone:'เพื่อการใช้งานที่มีคุณภาพ เข้าสู้ระบบโดยเว็บไซต์',
      choose_banks:'โปรดเลือกธนาคารของท่าน',
      bind_bank_account:'ผูกบัญชีผ่านธนาคาร',
      home_my:'ของฉัน',
      other_gj:'อุปกรณ์อื่นๆ',
      loan_record:'บันทึกเงินกู้',
      sch_sh:'ตรวจสอบ',
      yys_tip:'ระบบเชื่อมต่อเครือข่ายมือถือ เพื่อทำการยืนยันข้อมูลส่วนตัว',
      choose_yys:'เลือกเครือข่ายของท่าน',
      rz_intro:'คำแนะนำการรับรอง',
      rz_intro1:'ยืนยันหมายเลขโทรศัพท์มือถือ จำเป็นต้องยืนยันชื่อจริงของผู้ให้บริการ',
      rz_intro2:'เลขรับรองต้องตรงกับเลขที่ลงทะเบียน',
      rz_intro3:'หากคุณลืมรหัสผ่านบริการ คุณสามารถโทรไปที่การตั้งค่าโทรศัพท์ของผู้ให้บริการได้',
      start_rz:'เริ่มการยืนยัน',
      gxntjcg:'ยินดีด้วยทำการสำเร็จ',
      fksjts:'เงินกู้ได้รับการอนุมัติในวันเดียวกัน หากวันอนุมัติหรือวันเงินกู้ถูกเลื่อน วันที่ชำระคืนจะถูกเลื่อนออกไปตามนั้น',
      bank_rz:'ตรวจสอบบัตรธนาคาร',
      bank_rz_tips:'เพิ่มบัตรธนาคาร กรอกบัญชีธนาคารที่ถูกต้อง ข้อมูลธนาคารและข้อมูลส่วนบุคคลต้องสอดคล้องกัน คุณจะได้รับเงินกู้อย่างรวดเร็ว',
      basc_info_rz:'ตรวจสอบข้อมูลพื้นฐาน',
      basc_info_rz_tips:'ข้อมูลต่อไปนี้ใช้เพื่อทบทวนจำนวนเงินกู้เท่านั้น และเราจะปกป้องข้อมูลของคุณตามกฎหมาย',
      ipt_u_xm:'กรุณาพิมพ์ชื่อของคุณ',
      ipt_u_bir:'วัน เดือน ปี เกิด',
      ipt_u_edu:'ระดับการศึกษา',
      ipt_u_marr:'สถานะภาพ',
      ipt_u_income:'รายได้',
      photo_rz:'เลขบัตรประจำตัวประชาชน',
      photo_rz_tip:'ถ่ายรูปหน้าบัตรประชาชน',
      psyq:'ถ่ายรุปกับหน้าบัตรประชาชน',
      psyq_sfz:'ถ่ายรูปหน้าบัตรเห็นเลขบัตร',
      psyq_sfz_bk:'ใส่รูปอยู่ให้ในกรอบ',
      bz:'มาตรฐาน',
      bkqs:'ไม่ตรงกรอบ',
      zpmh:'รูปถ่ายไม่ชัดเจน',
      sgql:'สะท้อนแสง',
      social_rz:'การตรวจสอบทางสังคม',
      social_rz_tips:'ข้อมูลต่อไปนี้ใช้สำหรับวงเงินตรวจสอบสินเชื่อเท่านั้นเราอาจติดต่อญาติของคุณและสัญญาว่าจะเก็บข้อมูลของคุณเป็นความลับตามกฎหมาย',
      social_rz_tips2:'ระหว่างการตรวจสอบ เราจะใช้ข้อมูลข้างต้นเป็นข้อมูลอ้างอิง กรุณากรอกข้อมูลเพื่อให้แน่ใจว่าคุณได้รับเงินกู้จำนวน',
      repay_yq:'เกินกำหนด',
      repay_yq1:'ชำระเงินให้ตรงเวลา เพื่อไม่ให้เสียเคดิต',
      repay_yq2:'เกินกำหนดแล้ว รีบทำการชำระ',
      male:'ชาย',
      Female:'หญิง',
      tel_psd_rz:'ต้องระบุโทรศัพท์หรือรหัสผ่าน',
      qxz_sty:'เลือก',
      yys_reset_wjmm:'ลืมรหัสผ่าน',
      bank_yhmc:'ชื่อ ธนาคาร',
      repay_skzh:'เลขบัญชี',
      tian:'วัน',
      edit_cs_psd:'รหัสผ่านเข้าสู่ระบบเดิมของ คือ 111111 เพื่อความปลอดภัยของบัญชีของคุณ โปรดแก้ไขรหัสผ่านสำหรับเข้าสู่ระบบในเวลาหลังจากการลงทะเบียน',
      index_jdlc:'ขั้นตอนการขอสินเชื่อที่ง่ายและปลอดภัย',
      index_syxq:'เชื่อมต่อทุกความต้องการสินเชื่อของคุณ',
      index_ksjklc:'ขั้นตอนการกู้ยืมที่รวดเร็ว',
      index_pro:'ผลิตภัณฑ์สินเชื่อของเรา',
      index_ty:'นำประสบการณ์ดีๆมาให้คุณเมื่อคุณต้องการยืมเงิน',
      index_jd:'สินเชื่อมีหลายประเภท สินเชื่อออนไลน์มีความยืดหยุ่น และการดำเนินการชำระคืนก็ง่าย',
      index_tips:'เพื่อให้คุณได้รับประสบการณ์ที่ดียิ่งขึ้น เราได้ออกแบบแอปพลิเคชันให้ง่ายมากเพื่อช่วยให้คุณตรวจสอบข้อมูลได้ง่าย ใบสมัครที่คุณส่งมาจะได้รับการตรวจสอบทันทีและชำระเงินอย่างรวดเร็ว คุณสามารถติดตามสถานะการอนุมัติการลงทะเบียนและดำเนินการได้อย่างรวดเร็ว ช่วยให้คุณ ชำระคืนเงินกู้เมื่อใดก็ได้',
      loan_need:'ต้องการสินเชื่อเท่าไร',
      loan_ed:'วงเงินที่ต้องการ',
      we_solve:'วิธีการแก้ไข',
      all_ans:'คำถามและข้อสงสัยเกี่ยวกับสินเชื่อ',
      ybxx:'ปัญหาทั่วไป',
      ybxx_a:'ในการรับเงินกู้ คุณต้องเป็นพลเมืองของประเทศที่คุณอาศัยอยู่และมีบัตรประจำตัวที่ถูกต้อง',
      dk:'สินเชื่อ',
      dk_a:'หากคุณไม่ได้รับเงินกู้หลังจาก 2 ชั่วโมง โปรดติดต่อเราผ่านสายด่วน',
      dkzf:'ชำระสินเชื่อ',
      dkzf_a:'สามารถชำระเงินล่วงหน้าได้ คุณสามารถชำระเงินกู้ก่อนวันครบกำหนดได้',
      why_c:'ทำไมถึงเลือก',
      why_lh:'สินเชื่อที่ยืดหยุ่นและรวดเร็ว',
      why_1:'เงินกู้ทั้งหมดมีอัตราดอกเบี้ยต่ำมาก',
      why_2:'รับเงินกู้สำเร็จ',
      why_3:'ให้คุณผ่อนชำระได้อย่างคล่องตัว',
      why_apply:'ขั้นตอนการสมัครที่ง่ายและรวดเร็ว',
      why_4:'กรอกข้อมูลของท่าน',
      why_5:'ยื่นขอสินเชื่อ',
      why_6:'รับเงินกู้',
      jd:'ง่าย',
      tm:'โปร่งใส',
      aq:'ปลอดภัย',
      get_quck:'รับเงินกู้ของคุณได้อย่างรวดเร็ว',
      rz_succ:'ทำการสำเร็จ',
      first_rz:'请先认证基本信息',
      gg_detail:'Chi tiết thông báo'
    }
};




// WEBPACK FOOTER //
// ./src/i18/lang/th.js